import { useCallback, useEffect, useState } from "react";
import { listManufacturingMaterialsUsedInRecipes } from "@/lib/manufacturingClient";
import { useScopedOrganizationId } from "@/contexts/WorkspaceOrgContext";

/**
 * Distinct material IDs that appear on at least one recipe BOM (direct leaf
 * or Part-use member). Used by Inventory's "Not used in any recipe" filter.
 */
export function useManufacturingMaterialsRecipeUsage(opts: { enabled: boolean }) {
  const { enabled } = opts;
  const scopedOrganizationId = useScopedOrganizationId();
  const [usedMaterialIds, setUsedMaterialIds] = useState<ReadonlySet<string>>(
    () => new Set(),
  );
  const [ready, setReady] = useState(false);

  const load = useCallback(async () => {
    if (!enabled) {
      setUsedMaterialIds(new Set());
      setReady(false);
      return;
    }
    const r = await listManufacturingMaterialsUsedInRecipes();
    if (!r.ok) {
      setUsedMaterialIds(new Set());
      setReady(false);
      return;
    }
    const ids = Array.isArray(r.data.material_ids) ? r.data.material_ids : [];
    setUsedMaterialIds(new Set(ids.filter((id): id is string => typeof id === "string")));
    setReady(true);
  }, [enabled]);

  useEffect(() => {
    void load();
  }, [load, scopedOrganizationId]);

  return { usedMaterialIds, ready, refresh: load };
}
